var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4224",
    "data-name": "Rectangle 4224",
    width: 26,
    height: 26,
    transform: "translate(508 365)",
    fill: "#f28e39"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(-508 -365)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-01",
    transform: "translate(508.002 365.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9925",
    "data-name": "Path 9925",
    d: "M13,19.5V16.25",
    fill: "none",
    stroke: "#253348",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9926",
    "data-name": "Path 9926",
    d: "M10.909,3.055,3.4,9.068A3.654,3.654,0,0,0,2.2,12.22L3.64,20.843a3.456,3.456,0,0,0,3.293,2.784H19.066a3.476,3.476,0,0,0,3.293-2.784L23.8,12.22a3.715,3.715,0,0,0-1.2-3.153l-7.507-6A3.494,3.494,0,0,0,10.909,3.055Z",
    fill: "none",
    stroke: "#253348",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInactive);
export default __webpack_public_path__ + "static/media/home_inactive.c0314045592e00a05ff15e06f39cb91a.svg";
export { ForwardRef as ReactComponent };